import Cookies from 'js-cookie';
import pageView from '../../mixins/pageView';
import { validateHandoffUrl } from '../../utils/commonUtil';

export default {
  mixins: [pageView],
  filters: {
    formatCfpsId(value) {
      return (value || '')
        .split('')
        .reduce((acc, char, indx) => {
          if (indx > 0 && indx < 15 && indx % 4 === 3) {
            return `${acc}${char}-`;
          }

          return `${acc}${char}`;
        }, '');
    },
  },
  data() {
    return {
      progressStep: 1,
      current: 1,
      autofill: false,
      cfpsId: this.$route?.query?.cfpsId || '',
      dcoa: this.$route?.query?.dcoa || false,
      forwardType: '',
      mcoa: this.$route.query?.mcoa || false,
      moverType: '',
      unloadHandle: null,
      repromptShown: false,
      showReprompt: false,
      amp_data: [],
    };
  },
  computed: {
    showSimplifyExperience: () => JSON.parse(sessionStorage.getItem('showSimplifyExperience') ?? false),
    showChoiceExperience() {
      return this.showNonControlExperience || this.showExperienceA || this.showExperienceB;
    },
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')),
    showExperienceA: () => JSON.parse(sessionStorage.getItem('showExperienceA')),
    showExperienceB: () => JSON.parse(sessionStorage.getItem('showExperienceB')),
    failedIvsVerification: () => JSON.parse(sessionStorage.getItem('passedIvsVerification')) === false,
    flagAccessHandoffEnabled() {
      return this.$store.get('flagAccessHandoffEnabled');
    },
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
    offersSegment() {
      return this.offersBizSegment || this.offersIndFamTempSegment;
    },
    offersBizSegment() {
      return this.moverType === 'BUSINESS' && !this.mcoa;
    },
    offersIndFamTempSegment() {
      return this.moverType !== 'BUSINESS' && this.forwardType === 'TEMPORARY' && !this.mcoa;
    },
    voterRegSegment() {
      return this.forwardType === 'PERMANENT'
        && (this.moverType === 'INDIVIDUAL' || this.moverType === 'FAMILY')
        && !this.mcoa;
    },
    showCfpsId() {
      if ((this.forwardType === 'TEMPORARY' && this.dcoa) || this.failedIvsVerification) {
        return false;
      }
      return !!this.cfpsId;
    },
  },
  created() {
    // Email must be sent post instant-savings step
    // to account for selections in realtime deals email
    // do not fire email if there's no cfpsId set
    sessionStorage.removeItem('informedDelivery');
    if (this.cfpsId || this.dcoa) {
      this.$coa.emailSend();
    }
  },
  async mounted() {
    this.$coa.coaUUID = this.$route.params.orderUuid;
    const amp = JSON.parse(sessionStorage.getItem('amp_data')) ?? [];
    this.amp_data = [...this.amp_data, ...amp];
    if (this.flagAmpersendEnabled) {
      this.$amp.initSDK();
    }
    this.unloadHandle = window.addEventListener('unload', () => {
      localStorage.removeItem('agentId');
      localStorage.removeItem('audienceIds');
      localStorage.removeItem('experienceIds');
      localStorage.removeItem('ampersend_data');
    });

    this.pageView();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('unload', this.unloadHandle);

    if (to.name === 'disclaimer') {
      this.$coa.reset();
      this.$deleteSession();
      Cookies.remove('coa');
      Cookies.remove('coa_complete');
      localStorage.removeItem('ampersend_data');
    }

    next();
  },
  methods: {
    async getAmpersendExperiences() {
      this.amp_data = await this.$amp.getLiveExperiences() ?? [];
      const prev = JSON.parse(sessionStorage.getItem('amp_data'));
      this.amp_data = [...prev, ...this.amp_data];
      sessionStorage.setItem('amp_data', JSON.stringify(this.amp_data));
    },
    async hydrateCOA() {
      const { uuid, ...coa } = await this.$coa.coaGet() || [];

      if (uuid) {
        this.coa = coa;
        this.dcoa = coa.dcoa;
        this.forwardType = coa.forwardType;
        this.moverType = coa.moverType;
      }
    },
    /**
     * Perform handoff to Access flow
     * @param {String} dest Access flow
     */
    async handoff(dest) {
      if (dest === 'vr' && this.userNeedsReprompt) {
        this.showReprompt = true;
        return;
      }

      const { url } = await this.$coa.handoffGetURL(dest, this.autofill, this.$route.query);

      const validUrl = validateHandoffUrl(url);
      if (validUrl) {
        window.location.href = validUrl;
      }
    },
  },
};
